import { z } from 'zod';

export const SchedulingConfigurationDTOSchema = z
  .object({
    numberOfDays: z.number().int().positive(),
    validityInMinutes: z.number().int().positive(),
    reminderCount: z.number().int().min(0).max(10).optional(),
    reminderDelayMinutes: z.number().int().min(5).max(1440).optional(), // max 24 hours
    reminderText: z.string().max(60).optional(),
  })
  .superRefine((data, ctx) => {
    // Only validate reminder constraints if reminders are configured
    if (data.reminderCount && data.reminderCount > 0) {
      if (!data.reminderDelayMinutes) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: 'Reminder delay is required when reminder count is set',
          path: ['reminderDelayMinutes'],
        });
      }

      if (!data.reminderText) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: 'Reminder text is required when reminder count is set',
          path: ['reminderText'],
        });
      }

      if (
        data.reminderDelayMinutes &&
        data.reminderDelayMinutes >= data.validityInMinutes
      ) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message:
            'Reminder delay cannot be greater than or equal to questionnaire validity period',
          path: ['reminderDelayMinutes'],
        });
      }

      if (
        data.reminderDelayMinutes &&
        data.reminderCount * data.reminderDelayMinutes >= data.validityInMinutes
      ) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message:
            'Total reminder duration cannot exceed questionnaire validity period',
          path: ['reminderCount'],
        });
      }
    }
  });

export type SchedulingConfigurationDTO = z.infer<
  typeof SchedulingConfigurationDTOSchema
>;
